<template>
  <div v-if="hasError" class="app-alert-error app-system-alert" id="payError"
       role="alert" ref="payError">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <p ref="alertMessage" tabindex="-1">{{ message }}</p>
  </div>
</template>

<script setup>
import { computed, ref, onUpdated } from 'vue';
import MESSAGES from '@/assets/data/_systemFeedback';

/**
 * Same look/feel as SystemAlert but better not to mix & match since payment is unique and not as common.
 */

// Props
const props = defineProps({
  hasError: {
    type: Boolean,
    required: false,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: '',
  },
});

// Template Ref
const alertMessage = ref(null);

// Computed Properties
const catchAllError = computed(() => {
  // use generic catch-all message if card is supported but something else went wrong
  // const err = _.find(MESSAGES, item => item.code === 35);
  const err = MESSAGES.find(item => item.code === 35);
  return err ? err.message : 'Your payment was not successful! Please try again.';
});

const message = computed(() => {
  return (props.errorMessage.length > 0) ? props.errorMessage : catchAllError.value;
});

// Lifecycle Hook
onUpdated(() => {
  if (alertMessage.value) {
    alertMessage.value.focus();
  }
});
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
